import { Directive, Input, OnChanges } from '@angular/core';

@Directive({
  // tslint:disable-next-line: directive-selector
  selector: '[filterIcons]'
})

export class FilterIconDirective implements OnChanges {

  @Input() filterRows: any;
  @Input() pageIn = '';

  ngOnChanges(): void {
    if (this.filterRows && this.pageIn !== '') {
      this.assignPlaceHolder();
    }
  }

  assignPlaceHolder(): void {

    const filters = this.filterRows;
    const currentPage = this.pageIn;
    // FUTURE USE
    // switch (currentPage) {
    //   case 'Imports':
    //     filters[0].setAttribute('placeholder', 'Id');
    //     filters[1].setAttribute('placeholder', 'PPED');
    //     break;
    //   case 'Adjustments':
    //     filters[0].setAttribute('placeholder', '');
    //     filters[1].setAttribute('placeholder', '');
    //     filters[2].setAttribute('placeholder', '');
    //     break;
    //   case 'Payments':
    //     filters[0].setAttribute('placeholder', 'Id');
    //     filters[1].setAttribute('placeholder', 'Location');
    //     filters[2].setAttribute('placeholder', 'PPED');
    //     break;
    //   case 'Uploads':
    //     filters[0].setAttribute('placeholder', 'MM/DD/YYYY');
    //     filters[1].setAttribute('placeholder', 'Category');
    //     filters[2].setAttribute('placeholder', 'File');
    //     break;
    //   default:
    //     break;
    // }

    this.assignFilters(filters);
  }

  assignFilters(filters: any): void {
    // tslint:disable-next-line: max-line-length
    const filterIcon = '<span id="search-icon" style="padding-top:7px;margin-left:-19px;z-index:0;color:darkgrey;" class="k-icon k-i-search"></span>';
    for (const filter of filters) {
      filter.insertAdjacentHTML('afterend', filterIcon);
    }
  }
}
